import React from 'react';
import { Hero } from './components/sections/Hero';
import { PainHook } from './components/sections/PainHook';
import { MechanismReveal } from './components/sections/MechanismReveal';
import { DreamOutcome } from './components/sections/DreamOutcome';
import { WhyMethodsFail } from './components/sections/WhyMethodsFail';
import { ProductIntro } from './components/sections/ProductIntro';
import { WhatsInside } from './components/sections/WhatsInside';
import { Benefits } from './components/sections/Benefits';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { ProofStack } from './components/sections/ProofStack';
import { Pricing } from './components/sections/Pricing';
import { RiskReversal } from './components/sections/RiskReversal';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Closing } from './components/sections/Closing';
import { StickyMobileCta } from './components/ui/StickyMobileCta';
import { SalesPopNotifications } from './components/SalesPopNotifications';
interface AppProps {
  /** Muestra el bloque de escasez con la fecha de hoy y la nota de subida de precio. */
  showUrgency?: boolean;
  /** Muestra las notificaciones flotantes de compras recientes. */
  showSalesPop?: boolean;
}
export function App({
  showUrgency = true,
  showSalesPop = true
}: AppProps) {
  return <div className="w-full bg-white font-sans text-body antialiased" data-id="element-0" data-mp="2zmwggus3xgao">
      <Hero data-id="element-1" data-mp="33nq55qddiz4m" />
      <main data-id="element-2" data-mp="33n6yx6x35z6f">
        <PainHook data-id="element-3" data-mp="33mylndx1wrup" />
        <MechanismReveal data-id="element-4" data-mp="33ohzyyz5cstu" />
        <DreamOutcome data-id="element-5" data-mp="38l8h7pmotugu" />
        <WhyMethodsFail data-id="element-6" data-mp="38l03xwmnkn54" />
        <ProductIntro data-id="element-7" data-mp="38kgocmkh6au9" />
        <WhatsInside data-id="element-8" data-mp="3dkuu1xylt8p4" />
        <Benefits data-id="element-9" data-mp="3dle3sre3oqs2" />
        <Offer data-id="element-10" data-mp="3dlwa6guh8ldp" />
        <Testimonials data-id="element-11" data-mp="3dmfpdpsqsvo1" />
        <ProofStack data-id="element-12" data-mp="3dii3wxiozs0z" />
        <Pricing showUrgency={showUrgency} data-id="element-13" data-mp="nvsub5qlapwh" />
        <RiskReversal data-id="element-14" data-mp="nv0z3w0wmu6q" />
        <Faq data-id="element-15" data-mp="nxn4pq48izmb" />
        <FinalCta data-id="element-16" data-mp="sunby4ctm8f0" />
      </main>
      <Closing data-id="element-17" data-mp="stuclog6yl6w" />
      <StickyMobileCta data-id="element-18" data-mp="stc864jdl0nw" />
      {showSalesPop && <SalesPopNotifications data-id="element-19" data-mp="swgmvvugvest" />}
    </div>;
}